<template>
  <div>
    <span :style="color" @click="url" class="text-inherit hover:text-primary cursor-pointer">{{ params.value }}</span>
  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'

export default {
  name: 'CellRendererChip',
  computed: {
    color () {
      let color = 'primary'
      color = `padding: 4px; background-color: ${this.getColor(this.params.value).toString()};`
      return color
    }
  },
  methods: {
    async url () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      try {
        if (!operacionesStore.isRegistered) {
          this.$store.registerModule('operacionesStore', operacionesStore)
          operacionesStore.isRegistered = true
        }

        await this.$store.dispatch('operacionesStore/getOperacion', this.params.data.id)
          .then((response) => {
            this.operacion = response.data
            // this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          })
          .catch(
            // this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          )
      } catch (error) {
        console.error(error)
      }
      const ruta = `/gestion/operaciones/ver/${this.params.data.id}`
      this.$router.push(ruta).catch(() => {})
    },
    getColor (estado) {
      const filtradoOperacion = JSON.parse(JSON.stringify(this.$store.state.commonComponentsStore.estados)).filter(el => {
        return el.categoria === 'OPERACION'         
      })

      const estadoFiltrado = filtradoOperacion.filter(el => {
        return el.estado === estado         
      }).map(a => a.color)      
      return estadoFiltrado
    }
  }
}
</script>